import React, {useEffect, useState} from 'react'
import {useParams, useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'
import * as Api from 'lib/api'
import {ProductForm} from 'components/organisms/products'

export default function EditProductPage() {
  const {id} = useParams()
  const navigate = useNavigate()
  const intl = useIntl()
  const [isLoading, setIsLoading] = useState(true)
  const [errorMessage, setErrorMessage] = useState(null)
  const [product, setProduct] = useState(null)

  useEffect(() => {
    async function fetchData() {
      const result = await Api.getProductById(id)
      result.matchWith({
        Ok: ({value}) => {
          setProduct(value)
        },
        Error: ({value}) => {
          setErrorMessage(value.message)
        },
      })
      setIsLoading(false)
    }

    fetchData()
  }, [id])

  const handleSubmit = async (values) => {
    const result = await Api.updateProduct(product.id, values)
    result.matchWith({
      Ok: async ({value}) => {
        navigate(`/products/${value.id}`)
      },
      Error: ({value}) => {
        setErrorMessage(value.message)
      },
    })
  }

  if (isLoading) {
    return <h2>Loading...</h2>
  }

  if (errorMessage) {
    return <h2>Something went wrong!</h2>
  }

  return (
    <ProductForm
      initialValues={product}
      onSubmit={handleSubmit}
      errorMessage={errorMessage}
      submitLabel={intl.formatMessage({id: 'buttons.saveChanges'})}
      loadingText={intl.formatMessage({id: 'buttons.savingChanges'})}
      cancelTo={`/products/${product.id}`}
    />
  )
}
